<template>
  <div id="components-layout-demo-basic">
    <svg xmlns="http://www.w3.org/2000/svg" style="display: none;">
      <defs>
        <symbol id="icon-submit" viewBox="0 0 24 24">
					<g clip-rule="evenodd" fill-rule="evenodd"><path d="m20.045 10.166c.134.59.205 1.204.205 1.834 0 4.553-3.697 8.25-8.25 8.25s-8.25-3.697-8.25-8.25 3.697-8.25 8.25-8.25c.63 0 1.244.071 1.834.205.403.092.806-.162.897-.565.092-.404-.161-.806-.565-.898-.697-.158-1.422-.242-2.166-.242-5.381 0-9.75 4.369-9.75 9.75s4.369 9.75 9.75 9.75 9.75-4.369 9.75-9.75c0-.744-.084-1.469-.242-2.166-.092-.404-.494-.657-.898-.565-.403.091-.657.494-.565.897z"/><path d="m16.25 12c0 2.346-1.904 4.25-4.25 4.25s-4.25-1.904-4.25-4.25 1.904-4.25 4.25-4.25c.414 0 .75-.336.75-.75s-.336-.75-.75-.75c-3.174 0-5.75 2.576-5.75 5.75s2.576 5.75 5.75 5.75 5.75-2.576 5.75-5.75c0-.414-.336-.75-.75-.75s-.75.336-.75.75z"/><path d="m14.686 8.25299-2.098 2.09801c-.184-.065-.382-.101-.588-.101-.966 0-1.75.784-1.75 1.75s.784 1.75 1.75 1.75 1.75-.784 1.75-1.75c0-.206-.036-.404-.101-.588l2.098-2.09801 2.106.421c.246.05.5-.027.677-.205l3-3c.171-.17.249-.412.21-.65-.038-.238-.189-.443-.405-.551l-1.776-.888-.888-1.776c-.108-.216-.313-.367-.551-.405-.238-.039-.48.039-.65.21l-3 3c-.178.177-.255.431-.205.677zm3.109-3.987.534 1.069c.073.146.19.263.336.336l1.069.534-1.981 1.981-1.616-.323-.323-1.616z"/></g>
        </symbol>
      </defs>
    </svg>
    <a-layout>
      <!--   头部   -->
      <a-layout-header style="margin-top:10px;">
        <div class="container clearfix" style="position: relative;">
          <!--   Logo   -->
          <router-link tag="a" to="/">
            <div class="logo" style="display: inline-block;height:55px;float:left;padding-top:3px;">
              <img src="@/assets/Icons/TeamIcon.svg" alt="logo" style="width:38px;height:38px;vertical-align:top;">
              <span style="">Diggo Team</span>
            </div>
          </router-link>
        </div>
      </a-layout-header>
      <!--   内容   -->
      <a-layout-content>
        <!--   信息页   -->
				<div class="container">
					<div class="structure">
						<div class="boss-wrap">
							<div><span class="boss-item" @click="toTeamPage('leslie')">Leslie</span><span class="boss-connection">&</span><span class="boss-item" @click="toTeamPage('alan')">Alan</span></div>
							<a href="https://diggotech.feishu.cn/okr/user/7355435690474979331/" class="company-okr" target="_blank">
								<svg fill="#ffffff" viewBox="0 0 489.4 489.4" height="0px">
										<use xlink:href="#icon-submit"></use>
								</svg>
								<span>Company OKRs</span>
							</a>
						</div>
						<div class="mid-line">
							<div class="mid-line-item"></div>
							<div class="mid-line-item"></div>
						</div>
						<div class="line">
							<div class="line-item"></div>
							<div class="line-item"></div>
							<div class="line-item"></div>
							<div class="line-item"></div>
							<div class="line-item"></div>
							<div class="line-item"></div>
						</div>
						<div class="group-wrap">
							<div class="group-item" :class="item.group_okr == '' || item.group_okr == undefined  ? 'okr-null': ''" v-for="item in this.teamStructureList" :key="item.group_id">
								<div v-if="item.group_id != '8'" class="group-item-title">
									<!-- <span>{{ item.group_id === '8' ? 'Group E' : item.group_name }}</span> -->
									<span>{{ item.group_name }}</span>
									<a :href="item.group_okr == '' ? 'javascript:;' : item.group_okr" :target="item.group_okr == '' ? '_self' : '_blank' ">
										<svg viewBox="0 0 489.4 489.4" height="20px">
											<use xlink:href="#icon-submit"></use>
										</svg>
									</a>	
								</div>
								<div class="group-item-job-wrap">
									<div class="job-item" :class="single.individual_okr == null || single.individual_okr == '' ? 'okr-null': ''" v-for="single in item.members" :key="single.employee_id">
										<div class="job-item-title" @click="toTeamPage(single.username)">{{single.employee_id == "4" ? single.nickname : single.employee_id == "53" ? single.nickname : single.legal_name}}<span class="link-cover"></span></div>
										<a v-if="single.ee_type == 0" :href="single.individual_okr == null ? 'javascript:;' : single.individual_okr" :target="single.individual_okr == null ? '_self' : '_blank' ">
											<svg :fill="single.individual_okr == 'undefined' ? '#cccccc' : '#2177e9'" viewBox="0 0 489.4 489.4" height="14px">
												<use xlink:href="#icon-submit"></use>
											</svg>
										</a>
									</div>
								</div>
								<div class="group-item-practice-wrap">
									<div class="practice-item" v-for="single in item.practice" :key="single.employee_id">
										<div class="practice-item-title" @click="toTeamPage(single.username)">{{single.legal_name}}<span class="link-cover"></span></div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
      </a-layout-content>
    </a-layout>
    <Bug></Bug>
  </div>
</template>

<script>
import moment from 'moment'
import api from '@/common/api.js'
import Bug from '../../components/Bug.vue'

moment.suppressDeprecationWarnings = true

export default {
	name:'TGIF',
	components:{
			Bug
	},
  data() {
    return {
      teamStructureList:"",							//  团队结构列表
    }
  },
  methods: {
	// 获取团队结构列表
	getteamStructureList(){
		// this.$post(api.tool.teamStructure, {
		// 	timestamp: Date.parse(new Date()),
		// 	token: localStorage.impr_token,
		// 	employee_id: this.curUserId,
		// }) .then((res) => {
		// 	if(res.code == 200) {
		// 		this.teamStructureList = res.list
		// 		// this.teamStructureList[5].members.assign({"nickname": "Bonnie","employee_id": "53","username":"bonnie"})
		// 	}
		// })

		this.$post(api.tool.getAllGroupNew, {
			timestamp: Date.parse(new Date()),
			token: localStorage.impr_token,
			employee_id: this.curUserId,
		}) .then((res) => {
			if(res.code == 200) {
				let tempArr = res.list
				tempArr.shift()
				console.log(this.teamStructureList);
				this.teamStructureList = tempArr
			}
		})
	},
	// 前方员工信息页
    toTeamPage(name) {
			let routeUrl = this.$router.resolve({
				path:"/team/" + name,
			})
			window.open(routeUrl.href,'_blank')
			// this.$router.push({ path: '/team/' + name })
		}
  },
  created() {
    if (localStorage.impr_id && localStorage.impr_token) {
      this.avatar = localStorage.impr_picture
      this.curUserId = localStorage.impr_id
			this.getteamStructureList()

    } else {
      this.$router.push({ path: '/login' })
    }
  },

}
</script>

<style scoped>
/* Common */
#components-layout-demo-basic .ant-layout {
  background: #fff;
}
#components-layout-demo-basic .ant-layout-header,
#components-layout-demo-basic .ant-layout-footer {
  height: 55px;
  padding: 0;
  background: #fff;
  color: #000;
}
#components-layout-demo-basic .ant-layout-content {
  background: #fff;
  color: #fff;
  min-height: 1145px;
}
.container {
  /*width: 60%;*/
  width: 1195px;
  height: 100%;
  margin: 0 auto;
  color: #000;
}
.clearfix {
  content: '';
  display: block;
  clear: both;
}
/* Logo */
.logo span {
  line-height: 38px;
  margin-left: 10px;
  vertical-align: top;
  font-family: GoogleSans-Medium;
  font-size: 20px;
  font-weight: normal;
  font-stretch: normal;
  color: #1a73e8;
}
/* structure */
.structure {
	margin-top:50px;
	display: flex;
	flex-direction: column;
	align-items: center;
}
.boss-wrap {
	width:270px;
	height:120px;
	border: solid 2px #e8f0fa;
	border-radius: 8px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
}
.boss-item {
	font-family: GoogleSans-Medium;
	font-size: 18px;
	cursor: pointer;
	color: #333333;
}
.boss-item:hover {
	color:#2177e9
}
.boss-connection {
	font-size: 18px;
	margin:0 8px;
	color: #999999;
}
.company-okr {
	height:44px;
	width:210px;
	background: #2177e9;
	border-radius: 8px;
	line-height: 30px;
	text-align: center;
	margin-top:15px;
	color:#fff;
	display: flex;
	align-items: center;
	justify-content: center;
}
.company-okr span {
	margin-left:8px;
	font-family: GoogleSans-Medium;
}
.mid-line {
	height:40px;
	width:540px;
	display: flex;
}
.mid-line-item {
	width:50%;
	height:40px;
}
.mid-line-item:last-child {
	border-left:2px solid #e8f0fa;
}
.line {
	height:40px;
	width:1015px;
	display: flex;
}
.line-item {
	height:100px;
	width:16.6666%;
	border-left:2px solid #e8f0fa;	
	border-top:2px solid #e8f0fa;
}
.line-item:last-child {
	border-right:2px solid #e8f0fa;
}
.group-wrap {
	width:100%;
	display: flex;
	justify-content: space-between;
}
/* .group-item {
	float: left;
	width:180px;
	margin-right:23px;
}
.group-item:last-child{
	margin-right:0;
} */
.group-item-title {
	width:100%;
	height: 64px;
	background-color: #0a3266;
	border-radius: 8px;
	text-align: center;
	line-height:42px;
	font-family: GoogleSans-Bold;
	font-size: 18px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	color:#ffffff;
	padding:0 12px 0 17px;
	margin-bottom:16px;
}
.group-item-title a {
	display: flex;
	align-items: center;
}
.group-item-title svg {
	width:40px;
	height:40px;
	border-radius: 50%;
	padding:10px;
	margin-left: 8px;
	cursor: pointer;
	background: #234776;
	fill:#ffffff;
}
.group-item-title svg:hover {
	background:#2177e9;
}
.group-item.okr-null .group-item-title svg:hover {
	background: #234776;
	cursor: auto;
}
.group-item-job-wrap {
	display: flex;
	flex-direction: column;
	align-items: center;
}
.job-item,
.practice-item {
	width:100%;
	height: 64px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	border-radius: 8px;
	border: solid 1px #eeeeee;
	padding:0 12px 0 17px;
	margin-bottom:4px;
	cursor: pointer;
	position:relative
}
.link-cover {
	position:absolute;
	top:0;
	left:0;
	right:0;
	bottom:0;
	border-radius:8px;
}

.job-item .job-item-title ,
.practice-item .practice-item-title {
	flex:1;
	font-size: 16px;
	font-family: GoogleSans-Medium;
}
.job-item .job-item-title:hover .link-cover,
.practice-item .practice-item-title:hover .link-cover{
	border: solid 2px #2177e9;
}
.job-item.okr-null svg,
.group-item.okr-null > .group-item-title > a > svg {
	fill:#cccccc;
	cursor: auto;
}
.job-item.okr-null a:hover svg {
	background: #f8f8f8;
	fill:#cccccc;
}
.job-item a {
	display: flex;
	align-items: center;
	z-index:999;
}
.job-item a:hover svg {
	background: #2177e9;
	fill:#ffffff;
}

.job-item svg {
	width:40px;
	height:40px;
	border-radius: 50%;
	padding:10px;
	cursor: pointer;
	background: #f8f8f8;
	fill:#2177e9;
}

.group-item-practice-wrap {
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-top:16px;
}
</style>
